var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgTimeFuture = function SvgTimeFuture(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    role: "img",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M17 13h-4.75a.25.25 0 0 1-.25-.25V9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.5 12a.5.5 0 0 0-1 0h1m-1.753-3.855a.5.5 0 0 0 .62-.341l1.256-4.321a.5.5 0 0 0-.96-.28l-1.117 3.842-3.84-1.116a.5.5 0 0 0-.28.96zM21 12h-.5a8.5 8.5 0 0 1-2.124 5.621l.375.33.375.331A9.5 9.5 0 0 0 21.5 12zm-2.249 5.952-.375-.33a8.5 8.5 0 0 1-5.31 2.811l.062.496.063.496a9.5 9.5 0 0 0 5.935-3.143zm-5.623 2.977-.063-.496a8.5 8.5 0 0 1-5.843-1.403l-.28.414-.282.413a9.5 9.5 0 0 0 6.53 1.568zM6.94 19.444l.281-.414a8.5 8.5 0 0 1-3.455-4.916l-.484.124-.485.124a9.5 9.5 0 0 0 3.862 5.495zm-3.658-5.206.484-.124a8.5 8.5 0 0 1 .66-5.973l-.446-.227-.445-.227a9.5 9.5 0 0 0-.738 6.675zm.698-6.324.446.227A8.5 8.5 0 0 1 8.87 4.097l-.184-.465-.184-.465a9.5 9.5 0 0 0-4.967 4.52zm4.706-4.282.184.465a8.5 8.5 0 0 1 6.008-.094l.17-.47.17-.471a9.5 9.5 0 0 0-6.716.105zm6.362-.1-.17.47a8.5 8.5 0 0 1 4.57 3.903l.438-.24.438-.241a9.5 9.5 0 0 0-5.107-4.362z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTimeFuture);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;